import { render, staticRenderFns } from "./PagesForm.vue?vue&type=template&id=227d1e14&scoped=true"
import script from "./PagesForm.vue?vue&type=script&lang=js"
export * from "./PagesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d1e14",
  null
  
)

export default component.exports